import { Howl, Howler } from 'howler';

export type SfxName = 'shoot' | 'enemy_hit' | 'player_hit' | 'level_up';

export type SfxAssetMap = Readonly<Record<SfxName, string>>;

class SoundManager {
  private instances = new Map<SfxName, Howl>();

  register(assets: SfxAssetMap): void {
    for (const name of Object.keys(assets) as SfxName[]) {
      if (this.instances.has(name)) continue;
      const howl = new Howl({
        src: [assets[name]],
        preload: true,
        html5: false,
      });
      this.instances.set(name, howl);
    }
  }

  play(name: SfxName): void {
    const howl = this.instances.get(name);
    if (!howl) {
      throw new Error(`[SFX] sound "${name}" is not registered`);
    }
    howl.play();
  }

  stop(name: SfxName): void {
    const howl = this.instances.get(name);
    if (!howl) return;
    howl.stop();
  }

  setMute(muted: boolean): void {
    Howler.mute(muted);
  }

  setVolume(volume: number): void {
    const clamped = Math.max(0, Math.min(1, volume));
    Howler.volume(clamped);
  }

  reset(): void {
    this.instances.clear();
  }
}

export const SFX = new SoundManager();
